export default "__VITE_ASSET__BVnd6iLl__"